import { render, staticRenderFns } from "./UserCoaTransactionTracker.vue?vue&type=template&id=718bd440"
import script from "./UserCoaTransactionTracker.vue?vue&type=script&lang=js"
export * from "./UserCoaTransactionTracker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports